import AddStorage from './AddStorage';
import Storages from './Storages';
import StorageDetail from './StorageDetail';
import EditStorage from './EditStorage';

export {AddStorage, Storages, StorageDetail, EditStorage};
